// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.expiration-date .ui-input {\n  width: 5.38rem;\n}\n", ""]);
// Exports
module.exports = exports;
